import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const toolsRoutes: Routes = [
  {
    path: 'tools',
    canActivate: [authGuard, clientIdGuard],
    loadComponent: () =>
      import('../components/tools/tools.component').then(
        (m) => m.ToolsComponent
      ),
    children: [
      {
        path: 'bins',
        loadComponent: () =>
          import('../components/tools/bin-tool/bin-tool.component').then(
            (m) => m.BinToolComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'mcc',
        loadComponent: () =>
          import('../components/tools/mcc-tool/mcc-tool.component').then(
            (m) => m.MccToolComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
    ],
  },
];
